import {
  RESET_USER_STATE_ACTION,
  PENDING_GET_USER_ACTION,
  SUCCESS_GET_USER_ACTION,
  FAILURE_GET_USER_ACTION,
  PENDING_GET_USER_ACCESSIBLE_SCOPE_ACTION,
  SUCCESS_GET_USER_ACCESSIBLE_SCOPE_ACTION,
  FAILURE_GET_USER_ACCESSIBLE_SCOPE_ACTION,
  PENDING_GET_USER_APPLICATION_SETTINGS_ACTION,
  SUCCESS_GET_USER_APPLICATION_SETTINGS_ACTION,
  FAILURE_GET_USER_APPLICATION_SETTINGS_ACTION
} from '../actionsTypes';

const initialState = {
  data: {
    permissions: [],
    scope: {
      level: {},
      access: {}
    }
  },
  accessibleScope: {},
  loading: false,
  error: false,
  errors: {}
};

const userReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PENDING_GET_USER_ACTION:
    case PENDING_GET_USER_ACCESSIBLE_SCOPE_ACTION:
    case PENDING_GET_USER_APPLICATION_SETTINGS_ACTION: {
      return {
        ...state,
        loading: true,
        error: false,
        errors: {}
      };
    }
    case SUCCESS_GET_USER_ACTION: {
      const {
        payload: { user }
      } = action;

      return {
        data: user,
        loading: false,
        error: false,
        errors: {}
      };
    }
    case SUCCESS_GET_USER_ACCESSIBLE_SCOPE_ACTION: {
      const {
        payload: { accessibleScope }
      } = action;

      return {
        ...state,
        accessibleScope,
        loading: false,
        error: false,
        errors: {}
      };
    }
    case SUCCESS_GET_USER_APPLICATION_SETTINGS_ACTION: {
      const {
        payload: { applicationSettings }
      } = action;

      return {
        ...state,
        applicationSettings,
        loading: false,
        error: false,
        errors: {}
      };
    }
    case FAILURE_GET_USER_ACTION:
    case FAILURE_GET_USER_ACCESSIBLE_SCOPE_ACTION:
    case FAILURE_GET_USER_APPLICATION_SETTINGS_ACTION: {
      const {
        payload: { errors }
      } = action;

      return {
        ...state,
        data: initialState.data,
        loading: false,
        error: true,
        ...errors
      };
    }
    case RESET_USER_STATE_ACTION:
      return initialState;
    default:
      return state;
  }
};

export default userReducer;
